/* eslint-disable */
import { useState, useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import Cookies from 'js-cookie';
import styles from './styles.module.css';
import { useModuleSettingsByName } from '../../../global-hooks';

const COOKIE_NAME = 'vsx_cookie';
const COOKIE_LIFETIME_DAYS = 150;

const CookieBanner = () => {
  const moduleSettings = useModuleSettingsByName('cookieBanner');
  const [visible, setVisible] = useState(!Cookies.get(COOKIE_NAME));
  const [panelOpen, setPanelOpen] = useState(false);
  const [analyticsAllowed, setAnalyticsAllowed] = useState(true);

  useEffect(() => {
    if (!visible && !Cookies.get(COOKIE_NAME)) setVisible(true);
  }, [visible]);

  if (!moduleSettings || !visible) return null;

  const {
    expires = COOKIE_LIFETIME_DAYS,
    cookieName = COOKIE_NAME,
    customization: {
      generalText,
      wrapperStyles = {},
      buttonPrimaryStyles = {},
      buttonSecondaryStyles = {},
      buttonTertiaryStyles = {}
    } = {}
  } = moduleSettings;

  const saveConsent = (val) => {
    Cookies.set(COOKIE_NAME, val, { expires });
    setVisible(false);
    window.dispatchEvent(new Event('cookieConsentUpdated'));
  };

  const acceptAll = () => saveConsent('all');
  const acceptNecessary = () => saveConsent('necessary');
  const acceptCustom = () => saveConsent(analyticsAllowed ? 'all' : 'necessary');

  return (
    <CookieConsent
      ButtonComponent={() => null}
      disableStyles={false}
      overlay={false}
      containerClasses={`VSX-CookieConsent-Container ${styles.wrapper}`}
      contentStyle={wrapperStyles}
      cookieName={cookieName}
      expires={expires}
    >
      <div className={styles.row}>
        <div className={styles.text}>
          {generalText ||
            'This site uses cookies. Some are essential; others help us improve your experience.'}
        </div>
        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.linkBtn}
            style={buttonTertiaryStyles}
            onClick={() => setPanelOpen((o) => !o)}
            aria-label={'Cookie settings'}
          >
            Cookie settings
          </button>

          <button
            className={styles.btnSecondary}
            style={buttonSecondaryStyles}
            onClick={acceptNecessary}
            aria-label={'Accept only necessary cookies'}
          >
            Accept only necessary cookies
          </button>

          <button
            className={styles.btnPrimary}
            style={buttonPrimaryStyles}
            onClick={acceptAll}
            aria-label={'Accept all cookies'}
          >
            Accept all cookies
          </button>
        </div>
      </div>

      {panelOpen && (
        <>
          <hr className={styles.divider} />

          <div className={styles.panel}>
            {/* Necessary (locked) */}
            <div className={styles.option}>
              <label className={styles.label}>
                <input type="checkbox" checked readOnly className={styles.switchNative} />
                <span className={styles.switch + ' ' + styles.locked} />
                <span className={styles.optionTitle}>Necessary cookies</span>
              </label>
              <p className={styles.optionDesc}>
                These cookies enable core functionality. The site cannot function properly without
                them.
              </p>
            </div>

            {/* Analytics */}
            <div className={styles.option}>
              <label className={styles.label}>
                <input
                  type="checkbox"
                  checked={analyticsAllowed}
                  onChange={(e) => setAnalyticsAllowed(e.target.checked)}
                  className={styles.switchNative}
                  aria-label={'Analytics cookies'}
                />
                <span className={styles.switch} />
                <span className={styles.optionTitle}>Analytics cookies</span>
              </label>
              <p className={styles.optionDesc}>
                Analytics cookies help us improve the website by collecting and reporting
                information on usage.
              </p>
            </div>
          </div>

          <div className={styles.panelButtons}>
            <button
              className={styles.btnPrimary}
              style={buttonPrimaryStyles}
              onClick={acceptCustom}
              aria-label={'Accept custom settings'}
            >
              Accept custom settings
            </button>
          </div>
        </>
      )}
    </CookieConsent>
  );
};

export default CookieBanner;
